import React from "react";

import { ABOUT } from "../../data/content";
import PageMeta from "../general/PageMeta";
import { PageLayout } from "../general/PageSections";
import Slideshow from "../general/Slideshow";

const About = () => {
  return (
    <PageLayout title={ABOUT.TITLE}>
      <PageMeta
        title={ABOUT.TITLE}
        description={ABOUT.DESCRIPTION}
      />
      <section className={"content-box"}>
        <h2 className={"content-box-heading"}>{ABOUT.HEADING}</h2>
        <hr className={"rule"} />
        <div className={"text-columns"}>
          {ABOUT.COLUMNS.map((text) => (
            <p key={text}>{text}</p>
          ))}
        </div>
      </section>
      <Slideshow
        photos={ABOUT.SLIDES}
        label={"Photos of the guesthouse"}
        className={"page-slideshow"}
        autoplayMs={5000}
      />
    </PageLayout>
  );
};

export default About;
